<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">
        {{ $t(template.languageTitle) }}
        <span v-if="itemMaxLength" class="max-length-guide">
          {{ $t('최대 입력 가능 갯수 : ') }} {{ $t(itemMaxLength) }}</span
        >
      </h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideLanguage"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <v-row v-if="obj">
          <v-col cols="12" class="col-md-11">
            <v-row>
              <v-col cols="12" :class="collength">
                <CollectionAutoComplete
                  v-model="obj.languageName"
                  :directInput="itemDirectInput('languageName')"
                  :rules="[
                    rules.required('languageName', true),
                    rules.maxlength('languageName'),
                    languageRule.duplicated(languages, -1),
                  ]"
                  itemKey="language"
                  :label="itemLabel('languageName')"
                  :readonly="isReadonly"
                  @change:item="item => autocomset(-1, item)"
                  :languageCertYn="languageCertYn"
                />
              </v-col>
              <v-col
                cols="12"
                :class="[collength, colclass]"
                v-if="obj.languageDirectYn == 'Y'"
              >
                <i-text-field
                  v-model="obj.languageScore"
                  :label="itemLabel('languageScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required('languageScore', true)]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                :class="[collength, colclass]"
                v-else-if="obj.isscore"
              >
                <i-text-field
                  v-model="obj.languageScore"
                  :label="itemLabel('languageScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('languageScore', true),
                    rules.maxlength('languageScore'),
                    languageRule.isnumber(),
                    languageRule.maxscore(obj),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]" v-else>
                <i-select
                  v-model="obj.languageScore"
                  :items="obj.grades"
                  :label="itemLabel('languageScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('languageScore', true),
                    rules.maxlength('languageScore'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-select>
              </v-col>
              <v-col
                v-if="language === 'B' || language === 'C'"
                cols="12"
                :class="[collength, colclass]"
              >
                <i-text-field
                  v-maxlength="'language_org'"
                  v-model="obj.languageOrg"
                  :label="itemLabel('languageOrg')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('languageOrg', true),
                    rules.maxlength('languageOrg'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <CommonDatePicker
                  :readonly="isReadonly"
                  :label="itemLabel('languageDate')"
                  useMaxCurrentDate
                  :rules="[rules.required('languageDate', true)]"
                  v-model="obj.languageDate"
                  :type="languageDateFormat === 'YYYY.MM' ? 'month' : 'date'"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-8 mb-md-0"
            :class="colclass"
          >
            <i-btn elevation="0" color="primary" block @click="add">저장</i-btn>
          </v-col>
        </v-row>
        <v-row v-if="obj">
          <v-col cols="12">
            <v-row v-if="language === 'C'" :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-text-field
                  v-maxlength="'language_number'"
                  :label="itemLabel('languageNumber')"
                  v-model="obj.languageNumber"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('languageNumber', true),
                    rules.maxlength('languageNumber'),
                  ]"
                ></i-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <v-row v-for="(item, i) in languages" class="mt-4" :key="'langRow' + i">
          <v-col cols="12" :class="{ 'col-md-11': !isReadonly }">
            <v-row>
              <v-col cols="12" :class="collength">
                <i-text-field
                  v-maxlength="'language_name'"
                  v-model="item.languageName"
                  :label="itemLabel('languageName')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('languageName'),
                          rules.maxlength('languageName'),
                          languageRule.duplicated(languages, i),
                        ]
                  "
                  :class="[leftRoundedClass]"
                  autocomplete="false"
                  readonly
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                :class="[collength, colclass]"
                v-if="item.languageDirectYn == 'Y'"
              >
                <i-text-field
                  v-model="item.languageScore"
                  :label="itemLabel('languageScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="isReadonly ? [] : [rules.required('languageScore')]"
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                :class="[collength, colclass]"
                v-else-if="item.isscore"
              >
                <i-text-field
                  v-model="item.languageScore"
                  :label="itemLabel('languageScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('languageScore'),
                          rules.maxlength('languageScore'),
                          languageRule.isnumber(),
                          languageRule.maxscore(item),
                        ]
                  "
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]" v-else>
                <i-select
                  v-model="item.languageScore"
                  :items="item.grades"
                  :label="itemLabel('languageScore')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('languageScore'),
                          rules.maxlength('languageScore'),
                        ]
                  "
                  @change="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-select>
              </v-col>
              <v-col
                v-if="language === 'B' || language === 'C'"
                cols="12"
                :class="[collength, colclass]"
              >
                <i-text-field
                  v-maxlength="'language_org'"
                  v-model="item.languageOrg"
                  :label="itemLabel('languageOrg')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('languageOrg'),
                          rules.maxlength('languageOrg'),
                        ]
                  "
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <CommonDatePicker
                  :readonly="isReadonly"
                  :label="itemLabel('languageDate')"
                  useMaxCurrentDate
                  :rules="[rules.required('languageDate')]"
                  v-model="item.languageDate"
                  @change="save(i)"
                  :type="languageDateFormat === 'YYYY.MM' ? 'month' : 'date'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="language === 'C'" cols="12" :class="rowclass">
                <i-text-field
                  v-maxlength="'language_number'"
                  v-model="item.languageNumber"
                  :label="itemLabel('languageNumber')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('languageNumber'),
                          rules.maxlength('languageNumber'),
                        ]
                  "
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-6 mb-md-0"
            :class="colclass"
            v-if="!isReadonly"
          >
            <i-btn
              elevation="0"
              color="normal"
              block
              outlined
              @click="remove(i)"
              >삭제</i-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { postAuthJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { mdiCalendarBlank } from '@mdi/js';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import { snack } from '@/plugins/dialog/api';
import CollectionAutoComplete from '@/components/common/CollectionAutoComplete.vue';
import { isObject } from '@/utils/util';

export default {
  components: { CollectionAutoComplete, CommonDatePicker },
  props: {
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.language?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.language?.oMaxLength ||
        this.opts.language?.oMaxLength > this.languages.length
      );
    },
    collength: function() {
      return {
        'col-md-4': this.language === 'A',
        'col-md-3': this.language === 'B' || this.language === 'C',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
  },

  mounted() {
    this.setting();
    /* ybm 점수 확인 팝업 닫힌 후 작동을 위한 이벤트 */
    window.addEventListener(
      'message',
      async function(event) {
        if (event.data === 'close') {
          if (document.ybmFrm) {
            this.obj.languageScore = document.ybmFrm.YBMRESULT_LEVEL.value;
            if (this.languageDateFormat === 'YYYY.MM') {
              this.obj.languageDate = document.ybmFrm.YBMRESULT_DATE.value.substring(
                0,
                6,
              );
            } else {
              this.obj.languageDate = document.ybmFrm.YBMRESULT_DATE.value;
            }
            if (this.language != 'A') {
              this.obj.languageOrg = document.ybmFrm.YBMRESULT_ORG.value;
              if (this.language == 'C') {
                this.obj.languageNumber =
                  document.ybmFrm.YBMRESULT_EXAMNO.value;
              }
            }
          }
          if (document.opicFrm) {
            const keywordMap = {
              AL: 'Advanced Low',
              IH: 'Intermediate High',
              IM1: 'Intermediate Mid 1',
              IM2: 'Intermediate Mid 2',
              IM3: 'Intermediate Mid 3',
              IL: 'Intermediate Low',
              NH: 'Novice High',
              NM: 'Novice Mid',
              NL: 'Novice Low',
            };
            this.obj.languageScore = keywordMap[
              document.opicFrm.OPIC_LEVEL.value
            ]
              ? keywordMap[document.opicFrm.OPIC_LEVEL.value]
              : document.opicFrm.OPIC_LEVEL.value;

            if (this.languageDateFormat === 'YYYY.MM') {
              this.obj.languageDate = document.opicFrm.OPIC_EXAMDATE.value.substring(
                0,
                6,
              );
            } else {
              this.obj.languageDate = document.opicFrm.OPIC_EXAMDATE.value;
            }
            if (this.language != 'A') {
              this.obj.languageOrg = '멀티캠퍼스';
              if (this.language == 'C') {
                this.obj.languageNumber = document.opicFrm.OPIC_EXAMID.value;
              }
            }
          }
        }
      }.bind(this),
    );
  },
  mixins: [DialogMixin],
  data: () => ({
    mdiCalendarBlank,
    test: false,
    obj: null,
    languages: [],
    language: '',
    languageDateFormat: '',
    itemSeq: 1,
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
    languageCertYn: 'N',

    languageRule: {
      isnumber() {
        return v => !v || (v && !isNaN(v)) || '숫자만 입력 가능합니다.';
      },
      maxscore(item) {
        return v =>
          (v && Number(v) <= item.maxscore) ||
          '최대 점수는 ' + item.maxscore + ' 입니다.';
      },
      duplicated(items, idx) {
        var names = [];
        if (items && Array.isArray(items)) {
          for (var i = 0; i < items.length; i++) {
            if (i != idx) {
              var item = items[i];
              names.push(item.languageName);
            }
          }
        }
        return v =>
          !v || (v && names.indexOf(v) < 0) || '이미 등록된 정보입니다.';
      },
    },
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      return label;
    },
    setting: function() {
      let $this = this;
      if (this.template.typeLanguage) {
        this.language = this.template.typeLanguage;
        if (this.opts) {
          for (let key in this.opts) {
            let prop = this.opts[key];
            if (prop.id.cvColumn === 'languageDate') {
              $this.languageDateFormat = prop.oFormat;
            } else if (prop.id.cvColumn === 'languageCertYn') {
              this.languageCertYn = prop.oRequireYn;
            }
          }
        }
        this.settingData();
        this.obj = this.defaultObj();
      }
    },
    settingData: function() {
      if (this.info.languages?.length) {
        this.itemSeq = this.info.languages[0].id.seq;
        this.languages = [];
        let $this = this;
        this.info.languages
          .filter(v => {
            if (v.languageDirectYn == 'Y') {
              v.languageScore = v.languageGrade;
              this.languages.push(v);
              return false;
            }

            return true;
          })
          .forEach(function(v) {
            var date = '';
            if (v.languageDate && $this.languageDateFormat === 'YYYY.MM.DD') {
              date =
                v.languageDate.substring(0, 4) +
                '-' +
                v.languageDate.substring(4, 6) +
                '-' +
                v.languageDate.substring(6, 8);
            } else if (
              v.languageDate &&
              $this.languageDateFormat === 'YYYY.MM'
            ) {
              date =
                v.languageDate.substring(0, 4) +
                '-' +
                v.languageDate.substring(4, 6);
            }
            var lang = {
              languageName: v.languageName,
              seq: v.id.seq,
              languageType: v.languageType,
              languageScore: v.languageScore,
              languageOrg: v.languageOrg,
              languageDirectYn: v.languageDirectYn,
              languageNumber: v.languageNumber,
              languageDate: date,
              datePicker: false,
              grades: [],
              maxscore: 1000,
              isscore: true,
            };
            const p = { searchWord: v.languageName, type: 'normal', rows: 20 };
            postAuthJson(
              'api/v1/' + $this.$route.params.tenantKey + '/cv/languages',
              p,
            )
              .then(res => {
                if (res && res.data && res.status === 200) {
                  var array = res.data.data;
                  if (array && Array.isArray(array)) {
                    array.forEach(function(vv) {
                      if (vv.name === lang.languageName.trim()) {
                        if (vv.evalType === 'score') {
                          lang['isscore'] = true;
                          lang['grades'] = [];
                          lang['maxscore'] = vv.score;
                        } else if (vv.evalType === 'grade') {
                          lang['isscore'] = false;
                          lang['grades'] = vv.collection;
                          lang['languageScore'] = v.languageGrade;
                        }
                      }
                    });
                  }
                }
                $this.languages.push(lang);
              })
              .catch(error => {
                console.log(error);
              });
            $this.itemSeq =
              $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
          });
      }
    },
    defaultObj: function() {
      return {
        languageName: '',
        seq: this.itemSeq++,
        languageScore: '',
        languageType: '',
        languageOrg: '',
        languageDate: '',
        languageDirectYn: null,
        languageNumber: '',
        datePicker: false,
        isscore: true,
        maxscore: 1000,
        grades: [],
      };
    },
    autocomset: function(i, item) {
      var tmp = i === -1 ? this.obj : this.languages[i];

      if (isObject(item)) {
        tmp.languageScore = '';
        tmp.isscore = item.evalType == 'score';
        if (tmp.isscore) {
          tmp.maxscore = item.score || 1000;
        } else {
          tmp.grades = item.collection || [];
        }

        if (item.type) {
          tmp.languageType = item.type;
        }
        tmp.languageDirectYn = item.directYn ?? 'N';
      }
      if (i !== -1) this.save(i);
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          this.$t('최대 입력 가능 갯수 : ') +
            `${this.opts.language.oMaxLength}`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.language &&
        this.opts.language.oRequireYn &&
        this.opts.language.oRequireYn == 'Y' &&
        this.languages.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      //저장 폼에 자격증 명까지 입력을 한 뒤 저장을 안 누른 경우
      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      var tmp = i === -1 ? this.obj : this.languages[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;
      const id = {
        annoId: this.$route.params.annoId,
        seq: tmp.seq,
      };
      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const p = {
        id: id,
        languageType: tmp.languageType,
        languageDate: tmp.languageDate?.replace(pattern, '') || '',
        languageOrg: tmp.languageOrg,
        languageName: tmp.languageName,
        languageDirectYn: tmp.languageDirectYn,
        languageNumber: tmp.languageNumber,
      };
      if (tmp.languageDirectYn == 'Y' || !tmp.isscore)
        p['languageGrade'] = tmp.languageScore;
      else p['languageScore'] = tmp.languageScore;
      this.$emit('save', p, 'language', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('LANGUAGE SAVE FAIL');
      } else {
        snack.info(
          `${this.$t(this.template.languageTitle)}이 저장 되었습니다.`,
        );
        if (i === -1) {
          this.languages.push(this.obj);
          this.obj = this.defaultObj();
          this.$refs.saveForm.resetValidation();
        }
      }
    },
    delete: function(i) {
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.languages[i].seq,
      };
      this.$emit('delete', p, 'language', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('LANGUAGE DELETE FAIL');
      } else {
        snack.danger(
          `${this.$t(this.template.languageTitle)}이 삭제 되었습니다.`,
        );
        this.languages.splice(i, 1);
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
